import { toast } from "vue3-toastify";

export const months = [
  { id: "01", name: "Janeiro" },
  { id: "02", name: "Fevereiro" },
  { id: "03", name: "Março" },
  { id: "04", name: "Abril" },
  { id: "05", name: "Maio" },
  { id: "06", name: "Junho" },
  { id: "07", name: "Julho" },
  { id: "08", name: "Agosto" },
  { id: "09", name: "Setembro" },
  { id: "10", name: "Outubro" },
  { id: "11", name: "Novembro" },
  { id: "12", name: "Dezembro" },
];
export function getInitials(name) {
  const parts = name.trim().split(" ");
  const firstLetterName = parts[0]?.[0]?.toUpperCase() || "";
  const firstLetterNickName = parts[1]?.[0]?.toUpperCase() || "";

  return firstLetterName + firstLetterNickName;
}
export const getMatchedMonth = (searchMonth) => {
  console.log("====================================");
  console.log(searchMonth);
  console.log("====================================");
  const m = months.find((m) => m.id === searchMonth);

  return m.name;
};
// Função para formatar a data

export const formatDates = (dateFormat) => {
  const data = new Date(dateFormat);

  const day = data.getDate();
  const month = data.getMonth() + 1;
  const year = data.getFullYear();
  const hours = data.getHours();
  const minutes = data.getMinutes();
  const seconds = data.getSeconds();

  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
};

export const getValidMonths = () => {
  const months = [
    "Janeiro",
    "Fevereiro",
    "Março",
    "Abril",
    "Maio",
    "Junho",
    "Julho",
    "Agosto",
    "Setembro",
    "Outubro",
    "Novembro",
    "Dezembro",
  ];

  let today = new Date();
  let currentDay = today.getDate();
  let currentYear = today.getFullYear();
  let currentMonth = today.getMonth();

  const listMonths = [];
  const startYear = 2025;

  for (let year = startYear; year <= currentYear; year++) {
    for (let month = 0; month < 12; month++) {
      if (year === currentYear) {
        if (
          month > currentMonth ||
          (month === currentMonth && currentDay < 22)
        ) {
          continue;
        }
      }

      listMonths.push({
        id: `${String(month + 1).padStart(2, "0")}/${year}`,
        name: `${months[month]} ${year}`,
      });
    }
  }

  return listMonths.reverse();
};

export const getAllMonths = () => {
  const months = [
    "Janeiro",
    "Fevereiro",
    "Março",
    "Abril",
    "Maio",
    "Junho",
    "Julho",
    "Agosto",
    "Setembro",
    "Outubro",
    "Novembro",
    "Dezembro",
  ];

  let today = new Date();
  let currentDay = today.getDate();
  let currentYear = today.getFullYear();
  let currentMonth = today.getMonth();

  const listMonths = [];
  const startYear = 2025;

  for (let year = startYear; year <= currentYear; year++) {
    for (let month = 0; month < 12; month++) {
      if (year === currentYear) {
        // if (
        //   month > currentMonth ||
        //   (month === currentMonth && currentDay < 22)
        // ) {
        //   continue;
        // }
      }

      listMonths.push({
        id: `${String(month + 1).padStart(2, "0")}/${year}`,
        name: `${months[month]} ${year}`,
      });
    }
  }

  return listMonths.reverse();
};

export const getAllYear = () => {
  let today = new Date();
  let currentDay = today.getDate();
  let currentYear = today.getFullYear();
  let currentMonth = today.getMonth();

  const listMonths = [];
  const startYear = 2025;

  for (let year = startYear; year <= currentYear; year++) {
    for (let month = 0; month < 12; month++) {
      listMonths.push({
        id: `${String(month + 1).padStart(2, "0")}/${year}`,
        name: `${months[month]} ${year}`,
      });
    }
  }

  return listMonths.reverse();
};

// funcao para formatar valor com mz
export const moneyFormat = (money) => {
  if (typeof money == "string") {
    money = money.replace(",", ".");
  }
  const number = parseFloat(money);
  if (isNaN(number)) {
    return "-------------";
  }
  const formatter = new Intl.NumberFormat("MZ", {
    style: "currency",
    currency: "MZN",
  });

  return formatter.format(number);
};

// Gera um codigo com quatro digitos
function generateRandomString() {
  try {
    let characters = "0123456789";
    let charactersLength = 10;
    let lengthString = 4;

    let randomString = "";
    for (let i = 0; i < lengthString; i++) {
      randomString += characters.at(rand(0, charactersLength - 1));
    }

    return "FT000" + randomString;
  } catch (error) {
    return error;
  }
}

function rand(min, max) {
  return Math.floor(Math.random() * (min - max + 1)) + min;
}

// Funcao para formatar valor sem o mz
function numberFormat(
  number,
  decimals = 2,
  decimalSeparator = ".",
  thousandSeparator = ","
) {
  number = parseFloat(number);

  if (isNaN(number)) {
    return "";
  }

  const fixedNumber = number.toFixed(decimals);
  const [integerPart, decimalPart] = fixedNumber.split(".");

  const formattedInteger = integerPart.replace(
    /\B(?=(\d{3})+(?!\d))/g,
    thousandSeparator
  );

  return decimalPart
    ? `${formattedInteger}${decimalSeparator}${decimalPart}`
    : formattedInteger;
}

let listYear = [];

export const getYear = () => {
  let today = new Date();
  const startYear = 1999;
  let currentYear = today.getFullYear();

  for (let year = startYear; year <= currentYear; year++) {
    listYear.push(year);
  }

  return listYear.reverse();
};

export const onUserTypeBithDate = (birthDate) => {
  let currentYear = new Date().getFullYear();
  let year = new Date(birthDate).getFullYear();

  if (birthDate !== "") {
    if (currentYear - year < 18) {
      return toast.info("Menor de idade", { autoClose: 1000 });
    } else {
      return null;
    }
  }
};
